module.exports = __webpack_public_path__ + "img/portfolio-08-03-670x479.7ab69ffa.jpg";